<template>
  <div class="modal business-modal-delete">
    <div class="business-modal-delete-wrapper">
      <div class="business-modal-delete__content modal-card">
        <i class="icon-close" @click="$emit('closeModal')"></i>
        <div class="modal-card__header">
          <h3>Advertencia</h3>
        </div>
        <div class="modal-card__body">
          <p>¿Está seguro que desea eliminar esta empresa?</p>
          <div class="modal-card__action">
            <md-button @click="$emit('closeModal')">Cancelar</md-button>
            <md-button class="md-raised md-accent" @click="deleteBusiness">Eliminar Empresa</md-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BusinessModalDelete",
  props: ["businessId"],
  methods: {
    deleteBusiness() {
      this.$store.dispatch("delBusiness", this.businessId).then(res => {
        if (res.status == 200) {
          this.$toasted.success(`Empresa Eliminada`, {
            theme: "bubble",
            position: "top-right",
            duration: 5000,
            className: "short-message"
          });
          this.$store.dispatch("getBusiness");
        } else {
          this.$toasted.success(`${res.detail}`, {
            theme: "bubble",
            position: "top-left",
            duration: 5000,
            className: "short-message"
          });
        }
        this.$emit("closeModal");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.business-modal-delete {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
}
.business-modal-delete-wrapper {
  position: relative;
}
.modal-card {
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;
  background-color: #ffffff;
  border-radius: 5px;
  min-width: 400px;
  .icon-close {
    position: absolute;
    top: -8px;
    right: -8px;
    background-color: #ffffff;
    text-align: center;
    // border: thin solid #cdcdcd;
    box-shadow: 0px 0.5px 2px 1px rgba(0, 0, 0, 0.5);
    padding: 0.3rem 0.5rem;
    cursor: pointer;
    border-radius: 50%;
  }
  &__header {
    padding: 1rem;
    border-bottom: thin solid #cdcdcd;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
  }
  &__body {
    padding: 1rem 0 0 0;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-around;
    align-items: stretch;
    p {
      text-align: center;
      font-size: 16px;
    }
  }
  &__action {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
    padding: 0.5rem;
    margin-top: 1rem;
    // border-top: thin solid #cdcdcd;
  }
}
</style>